"use client";

import React from "react";
import { Sparkles, ArrowRight } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
export default function Vision() {
  const shouldReduceMotion = useReducedMotion();
  const fadeInVariants = {
    hidden: {
      opacity: 0,
      y: shouldReduceMotion ? 0 : 20
    },
    visible: (custom: number) => ({
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        delay: custom * 0.15,
        ease: "easeOut"
      }
    })
  };
  return <section id="heropentecostvision" data-nav="dark"
  /* Añadido min-h-[100dvh] y flex items-center para centrado absoluto en pantalla completa */ className="relative w-full min-h-[100dvh] flex items-center justify-center overflow-hidden text-foreground bg-black font-['Switzer',sans-serif]">
      {/* Fondo e Imágenes */}
      <div className="absolute inset-0 -z-10">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/worship_gathering_crowd.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/worship_gathering_crowd.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/worship_gathering_crowd.png-wvc-sizes" alt="Multitud reunida en adoración y celebración de Pentecostés" className="w-full h-full object-cover object-center" loading="lazy" decoding="async" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/60 to-black/75" />
        <div className="absolute inset-0 bg-primary/25 mix-blend-multiply" />
      </div>

      {/* Contenido Principal: z-10 para estar sobre el fondo, sin paddings que desvíen el centro */}
      <div className="relative z-10 w-full px-4 sm:px-6 flex flex-col items-center justify-center text-center">
        
        {/* Badge */}
        <motion.div custom={0} initial={shouldReduceMotion ? "visible" : "hidden"} animate="visible" variants={fadeInVariants} className="mb-4 sm:mb-6">
          <Badge variant="outline" className="text-foreground justify-center border w-fit whitespace-nowrap shrink-0 px-4 py-1.5 text-xs uppercase tracking-widest font-normal border-secondary/60 backdrop-blur-sm rounded-full inline-flex items-center gap-2 text-white bg-black sm:text-sm font-['Switzer',sans-serif]">
            <Sparkles className="size-3.5 text-secondary" />
            <span>2033: 2000 Años de Pentecostés</span>
          </Badge>
        </motion.div>

        {/* Título en 2 líneas */}
        <motion.h1 custom={1} initial={shouldReduceMotion ? "visible" : "hidden"} animate="visible" variants={fadeInVariants} className="w-full text-4xl sm:text-5xl md:text-6xl lg:text-7xl uppercase tracking-tight leading-[1.1] mb-6 drop-shadow-md text-[#3494e2] font-normal font-['Switzer',sans-serif]">
          <span className="block sm:whitespace-nowrap">UN MILLÓN DE IGLESIAS</span>
          <span className="block sm:whitespace-nowrap">AL 2033</span>
        </motion.h1>

        {/* Subtítulo en 2 líneas */}
        <motion.p custom={2} initial={shouldReduceMotion ? "visible" : "hidden"} animate="visible" variants={fadeInVariants} className="w-full text-lg sm:text-2xl md:text-3xl font-normal uppercase tracking-widest text-white/90 mb-10 drop-shadow-sm font-['Switzer',sans-serif]">
          <span className="block sm:whitespace-nowrap">SU MANDATO.</span>
          <span className="block sm:whitespace-nowrap">NUESTRA MISIÓN.</span>
        </motion.p>

        {/* Botones */}
        <motion.div custom={3} initial={shouldReduceMotion ? "visible" : "hidden"} animate="visible" variants={fadeInVariants} className="flex flex-col sm:flex-row items-center justify-center gap-4 w-full sm:w-auto">
          <Button asChild size="lg" className="w-full sm:w-auto rounded-full px-8 py-6 text-base font-normal shadow-lg transition-transform hover:scale-105 active:scale-95 font-['Switzer',sans-serif]">
            <Link to="/MissionsPage">
              <span>Nuestra misión</span>
              <ArrowRight className="size-4 ml-1" />
            </Link>
          </Button>

          <Button asChild variant="outline" size="lg" className="w-full sm:w-auto rounded-full px-8 py-6 text-base font-normal border-2 border-secondary text-white backdrop-blur-sm shadow-lg transition-all bg-[#080808] active:scale-95 hover:bg-secondary hover:text-secondary-foreground hover:scale-105 hover:border-[rgb(255,128,0)] font-['Switzer',sans-serif]">
            <Link to="/AboutUsPage">
              <span>Nuestro compromiso</span>
            </Link>
          </Button>
        </motion.div>
      </div>
    </section>;
}